import * as React from 'react';

import { inject, observer } from 'mobx-react';

import { catalogConfig, getConfig, URLS } from '@constants';

import { EContext, ERefsApps, EResponseStatus, EStore, EAppsCounters } from '@enums';

import { commonWillUnmount, fetchData } from '@decorators';

import { IAppState } from '@stores';

import { CompilationPage, OuterWrapper } from '@components';

import { ICGIUrlOptions } from '@interfaces/utils';

import { ICatalogNewProps, ICatalogNewState, IMatchParams } from './types';

@inject(
	EStore.APPS_NEW,
	EStore.UI,
	EStore.CURRENT_USER,
	EStore.MAIN_MENU_APPS,
	EStore.COUNTERS,
)
@observer
@commonWillUnmount()
@fetchData([
	async (
		{ appsNewStore, uiStore, currentUserStore: { currentUser: user } }: IAppState,
		{ page }: IMatchParams,
	) => {
		if (appsNewStore.status !== EResponseStatus.OK) {
			const limit = Boolean(user?.isMyCreated)
				? catalogConfig.appsLimit.auth
				: catalogConfig.appsLimit.guest;
			const offset = Boolean(user?.isMyCreated)
				? 0 // для авторизованного юзера показываем без сдвига
				: limit * (Number(page) - 1);

			await appsNewStore.fetch({
				context: EContext.MOBILE,
				limit,
				offset,
				user,
			});
		}
	},

	// UI STATE
	({ uiStore }: IAppState) => {
		if (uiStore.status !== EResponseStatus.OK) {
			uiStore.setTopMenuInitialState({
				backButtonUrl: getConfig().apps.pathname || URLS.APPS,
			});
		}
	},
])
export class CatalogNew extends React.Component<ICatalogNewProps, ICatalogNewState> {

	componentWillUnmount(): void {
		this.props.appsNewStore.clearStore();
	}

	fetchApps = async (options: ICGIUrlOptions) =>
		await this.props.appsNewStore.fetch(options);

	fetchAppsNext = async (options: ICGIUrlOptions) =>
		await this.props.appsNewStore.fetchNext(options);

	render() {
		const store = this.props.appsNewStore;
		const appsListOptions = {
			apps: store.data?.apps || [],
			responseStatus: store.status,
			urlRef: ERefsApps.PAGE_NEW,
			hasGenres: true,
			hasDescription: true,
		};

		return (
			<OuterWrapper>
				<CompilationPage
					appsListOptions={appsListOptions}
					fetchApps={this.fetchApps}
					fetchAppsNext={this.fetchAppsNext}
					compilationDescription={getConfig().apps?.compilationDescription?.new}
					total={store?.data?.total}
					hasMore={store?.data?.hasMore}
					paginationCounter={EAppsCounters.PAGINATOR_NEW}
				/>
			</OuterWrapper>
		);
	}

}
